import { useStore } from "./useStore.js";
export const useStoreId = function () {
  let {
    varnish = true,
    online = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    storeId
  } = useStore({
    varnish,
    online
  });
  return storeId;
};
//# sourceMappingURL=useStoreId.js.map